import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Descriptions,
  Drawer,
  Divider,
  Button,
  Input,
  notification
} from "antd";
import * as DateFormater from "../../../../../utils/DateFormater";
import * as MoneyFormater from "../../../../../utils/MoneyFormater";
import DiasEmAtraso from "./DiasEmAtraso";
import api from "../../../../../services/api";
import { NovoNumeroContratoField } from "./NovoNumeroContratoField";
import { NovoProdutoCarteiraField } from "./NovoProdutoCarteiraField";
import { NumeroClienteField } from "./NumeroClienteField";

export default class AcordoInfos extends Component {
  static propTypes = {
    acordo: PropTypes.object,
    pasta: PropTypes.object
  };

  state = {
    acordo: this.props.acordo,
    operador: "",
    showDrawer: false,
    acordoDescriptionExpanded: false
  };

  async UNSAFE_componentWillReceiveProps(newProps) {
    const operador = await this.getOperador(newProps.acordo.operador);
    this.setState({
      acordo: newProps.acordo,
      operador: operador
    });
  }

  // componentWillMount() {
  //   console.log('props', this.props)
  //   this.setState({
  //     acordo: this.props.acordo
  //   });
  // }

  handleInfos = () => {
    let descriptions = null;

    let pendente = this.state.acordo.valor_acordo - this.state.acordo.recebido;

    if (pendente <= 0) {
      pendente = 0;
    }

    let acordoDesc = this.state.acordo.notes || "";
    const displayShowMoreButton = acordoDesc.length > 200;

    if (acordoDesc.length > 200 && !this.state.acordoDescriptionExpanded) {
      acordoDesc = acordoDesc.substring(0, 200) + "...";
    } else {
      acordoDesc = this.state.acordo.notes;
    }

    descriptions = (
      <React.Fragment>
        <Descriptions title="Informações do acordo" size="middle" column={3}>
          <Descriptions.Item label="Valor original">
            <div className="acordoinfo__value">
              R$ {MoneyFormater.format(this.props.pasta.valor_divida)}
            </div>
          </Descriptions.Item>

          <Descriptions.Item label="Valor acordo">
            <div className="acordoinfo__value">
              R$ {MoneyFormater.format(this.state.acordo.valor_acordo)}
            </div>
          </Descriptions.Item>

          <Descriptions.Item label="Valor contrato">
            <div className="acordoinfo__value">
              R$ {MoneyFormater.format(this.state.acordo.valor_contrato)}
            </div>
          </Descriptions.Item>

          <Descriptions.Item label="Parcelas">
            <div className="acordoinfo__value">
              {`${this.state.acordo.parcela_set.length}x`}
            </div>
          </Descriptions.Item>

          <Descriptions.Item label="Operador">
            <div className="acordoinfo__value">{this.state.operador}</div>
          </Descriptions.Item>

          <Descriptions.Item label="Data do acordo">
            <div className="acordoinfo__value">
              {DateFormater.format(this.state.acordo.data_acordo)}
            </div>
          </Descriptions.Item>

          <Descriptions.Item label="Produto/Carteira">
            <div className="acordoinfo__value">{this.state.acordo.produto}</div>
          </Descriptions.Item>

          <Descriptions.Item label="Tipo Cobranca">
            <div className="acordoinfo__value">
              {this.state.acordo.tipo_cobranca}
            </div>
          </Descriptions.Item>

          {this.state.acordo.tipo_cobranca === "JUDICIAL" ? (
            <Descriptions.Item label="Numero Processo">
              <div className="acordoinfo__value">
                {this.state.acordo.numero_processo}
              </div>
            </Descriptions.Item>
          ) : null}
          <Descriptions.Item label="Dias em atraso">
            <div className="acordoinfo__value">
              <DiasEmAtraso
                acordo_id={this.props.acordo.id}
                dias_em_atraso={this.props.acordo.dias_em_atraso}
              />
            </div>
          </Descriptions.Item>
          <Descriptions.Item label="Novo Nº contrato">
            <div className="acordoinfo__value">
              <NovoNumeroContratoField
                acordoId={this.props.acordo.id}
                novoNumeroContrato={this.props.acordo.novo_numero_contrato}
              />
            </div>
          </Descriptions.Item>
          <Descriptions.Item label="Nova Carteira/Produto">
            <div className="acordoinfo__value">
              <NovoProdutoCarteiraField
                acordoId={this.props.acordo.id}
                novoProdutoCarteira={this.props.acordo.novo_produto_carteira}
              />
            </div>
          </Descriptions.Item>
          <Descriptions.Item label="Número cliente">
            <div className="acordoinfo__value">
              <NumeroClienteField
                acordoId={this.props.acordo.id}
                value={this.props.acordo.numero_cliente}
              />
            </div>
          </Descriptions.Item>
          <Descriptions.Item label="Participa campanha">
            <div className="acordoinfo__value">
              <b>{this.props.acordo.participa_campanha ? "Sim" : "Não"}</b>
            </div>
          </Descriptions.Item>
          <Descriptions.Item label="Nome campanha">
            <div className="acordoinfo__value">
              <b>{this.props.acordo.nome_campanha || "---"}</b>
            </div>
          </Descriptions.Item>
        </Descriptions>
        <Descriptions>
          <Descriptions.Item span={3} label="OBS">
            <div className="acordoinfo__value">
              {acordoDesc}
              {displayShowMoreButton && (
                <Button
                  type="link"
                  onClick={() =>
                    this.setState({
                      acordoDescriptionExpanded: !this.state
                        .acordoDescriptionExpanded
                    })
                  }
                >
                  {this.state.acordoDescriptionExpanded
                    ? "Ver menos"
                    : "Ver mais"}
                </Button>
              )}
            </div>
          </Descriptions.Item>
        </Descriptions>
      </React.Fragment>
    );
    return descriptions;
  };

  render() {
    const Infos = this.handleInfos();
    return (
      <div>
        {Infos}
        <Drawer
          visible={this.state.showDrawer}
          closable
          title="Editar Pessoa do Acordo"
          onClose={() => {
            this.setState({ ...this.state, showDrawer: false });
          }}
        >
          <br />
          <form onSubmit={this.handleSubmit}>
            <label>Nome</label>
            <Input
              className="ant-input"
              type="text"
              defaultValue={this.state.acordo.pessoa}
              id="pessoa"
            />
            <br />
            <br />
            <label>CPF/CPNJ</label>
            <Input
              className="ant-input"
              type="text"
              defaultValue={this.state.acordo.cpf_cnpj}
              id="cpf_cnpj"
            />
            <Divider type="horizontal" />
            <Button type="primary" htmlType="submit">
              Salvar
            </Button>
          </form>
        </Drawer>
      </div>
    );
  }

  getOperador = async id => {
    let operadores = await api.get("/pasta/users/");
    let operador = null;
    console.log(operadores);
    operadores.data.map(value => {
      if (value.id === id) {
        operador = value.username;
      }
    });
    return operador;
  };

  handleSubmit = async e => {
    e.preventDefault();
    const nome = document.getElementById("pessoa").value;
    const cpf_cnpj = document.getElementById("cpf_cnpj").value;
    const id_acordo = this.state.acordo.id;
    const params = {
      nome: nome,
      cpf_cnpj: cpf_cnpj
    };
    await api
      .put(`acordo/acordos/${this.props.acordo.id}/`, {
        pessoa: nome,
        cpf_cnpj: cpf_cnpj
      })
      .then(() => {
        notification.success({
          message: "Pessoa atualizada com sucesso!"
        });
      })
      .catch(err => {
        console.log(err);

        notification.error({
          message: "Não foi possível salvar a pessoa."
        });
      });
    this.setState({
      ...this.state,
      showDrawer: false,
      acordo: {
        ...this.state.acordo,
        pessoa: nome,
        cpf_cnpj: cpf_cnpj
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/pages/Acordo/View/AcordoView/AcordoInfos/index.js